import { render, staticRenderFns } from "./TopMenuNav.vue?vue&type=template&id=671eb5d3&"
import script from "./TopMenuNav.vue?vue&type=script&lang=js&"
export * from "./TopMenuNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports